import { GET, POST, PUT, DELETE, downloadUrl } from './api'

const table = "s3-download"

export const Create = async (params) => {
  return await POST(`/${table}`, params, true);
}

export const Read = async () => {
  return await GET(`/${table}`, true);
}

export const ReadOneS3Download = async (params) => {
  return await GET(`/${table}?${params}?populate=*`, true);
}

export const Update = async (params, id) => {
  return await PUT(`/${table}/${id}`, params, true);
}

export const Delete = async (id) => {
  return await DELETE(`/${table}/${id}`, true);
}

export const resolveDownloadFilename = (...candidates) => {
  for (const candidate of candidates) {
    if (typeof candidate === 'string' && candidate.trim()) return candidate.trim()
    if (!candidate || typeof candidate !== 'object' || Array.isArray(candidate)) continue

    const name = candidate.name || candidate.attributes?.name
    if (typeof name === 'string' && name.trim()) return name.trim()
  }

  return ''
}

export const buildS3DownloadUrl = ({
  sourceUrl,
  filename,
  disposition = 'attachment',
  endpoint = downloadUrl(),
}) => {
  if (typeof sourceUrl !== 'string' || !sourceUrl.trim()) return null

  const browserOrigin = typeof window !== 'undefined' ? window.location.origin : 'http://localhost'
  let endpointUrl
  let parsedSource
  try {
    endpointUrl = new URL(endpoint, browserOrigin)
    parsedSource = new URL(sourceUrl, endpointUrl)
  } catch (error) {
    return null
  }
  const isExistingProxy = parsedSource.pathname === endpointUrl.pathname
    && (parsedSource.searchParams.has('token') || parsedSource.searchParams.has('url'))
  const target = isExistingProxy
    ? new URL(`${endpointUrl.origin}${parsedSource.pathname}${parsedSource.search}`)
    : new URL(endpointUrl)

  if (!isExistingProxy) target.searchParams.set('url', sourceUrl)

  const resolvedFilename = resolveDownloadFilename(filename)
  if (resolvedFilename) target.searchParams.set('filename', resolvedFilename)
  if (disposition === 'inline') target.searchParams.set('disposition', 'inline')
  else target.searchParams.set('disposition', 'attachment')

  return target.toString()
}
